import React from "react"

class ImageDataType extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <a href={this.props.row.original_url} className="open-new-window" target="_blank"><span className="ss-scaleup"></span> <img src={this.props.row.thumb_medium_url}/></a>
    );
  }
};

export default ImageDataType